import React from 'react';

import classnames from 'classnames';

import { Card, CardContent } from '@andes/card';
import FileIcon from '../icons/icon_file';
import PropTypes from 'prop-types';
import { Title, Text } from '@andes/typography';
import { trackEvent } from '@vpp-frontend-components/common';

const namespace = 'ui-pdp-informative-box';

const InformativeBox = ({ title, subtitle, action, icon, border_color, className }) => (
  <div className={classnames(namespace, className)}>
    <Card
      className={classnames('ui-pdp-informative-box__card', {
        [`ui-pdp-border-color--${border_color}`]: border_color,
      })}
    >
      <CardContent className="ui-pdp-informative-box__card-content">
        {icon && (
          <div className="ui-pdp-informative-box__icon">
            <FileIcon className="ui-pdp-informative-box__icon--image" />
          </div>
        )}
        <div className="ui-pdp-informative-box__text">
          <Title
            component="h2"
            className={classnames('ui-pdp-informative-box__text--title', {
              [`ui-pdp-color--${title?.color}`]: title?.color,
              [`ui-pdp-size--${title?.font_size?.toLowerCase()}`]: title?.font_size,
              [`ui-pdp-family--${title?.font_family}`]: title?.font_family,
            })}
          >
            {title?.text}
          </Title>
          <Text
            className={classnames('ui-pdp-informative-box__text--description', {
              [`ui-pdp-color--${subtitle?.color}`]: subtitle?.color,
              [`ui-pdp-size--${subtitle?.font_size?.toLowerCase()}`]: subtitle?.font_size,
              [`ui-pdp-family--${subtitle?.font_family}`]: subtitle?.font_family,
            })}
            component="span"
          >
            {subtitle?.text}
            <Text
              component="a"
              className={classnames('ui-pdp-informative-box__text--description ui-pdp-informative-box__text--link', {
                [`ui-pdp-size--${subtitle?.font_size?.toLowerCase()}`]: subtitle?.font_size,
                [`ui-pdp-family--${subtitle?.font_family}`]: subtitle?.font_family,
              })}
              href={action?.target}
              onClick={() => {
                if (action?.track?.melidata_event) {
                  trackEvent(action?.track?.melidata_event);
                }
              }}
            >
              {' '}
              {action?.label?.text}
            </Text>
          </Text>
        </div>
      </CardContent>
    </Card>
  </div>
);

InformativeBox.propTypes = {
  className: PropTypes.string,
  title: PropTypes.shape({
    text: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    font_size: PropTypes.oneOf(['SMALL', 'MEDIUM', 'LARGE']).isRequired,
    font_family: PropTypes.oneOf(['REGULAR', 'SEMIBOLD', 'BOLD']).isRequired,
    has_andes_format: PropTypes.bool.isRequired,
  }).isRequired,
  subtitle: PropTypes.shape({
    text: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    font_size: PropTypes.oneOf(['SMALL', 'MEDIUM', 'LARGE']).isRequired,
    font_family: PropTypes.oneOf(['REGULAR', 'SEMIBOLD', 'BOLD']).isRequired,
    has_andes_format: PropTypes.bool.isRequired,
  }).isRequired,
  border_color: PropTypes.string,
  icon: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  action: PropTypes.shape({
    type: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
    label: PropTypes.shape({
      text: PropTypes.string.isRequired,
    }).isRequired,
    track: PropTypes.shape({
      melidata_event: PropTypes.shape({
        path: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        event_data: PropTypes.shape({
          item_id: PropTypes.string.isRequired,
          category_id: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default InformativeBox;
